import { useEffect } from "react";
import gsap from "gsap";
import ro from "/src/content/ro.json";

const Hero = () => {
  useEffect(() => {
    const el = document.querySelector(".hero-title");
    if (!el) return;

    const original = el.textContent || "";
    const frag = document.createDocumentFragment();
    el.textContent = "";
    original.split("").forEach((ch) => {
      const span = document.createElement("span");
      span.className = "char text-gradient";
      span.textContent = ch;
      frag.appendChild(span);
    });
    el.appendChild(frag);

    const chars = el.querySelectorAll(".char");
    const tween = gsap.from(chars, {
      yPercent: 100,
      ease: "expo.out",
      duration: 1.6,
      stagger: 0.05,
    });

    return () => {
      tween.kill();
      el.textContent = original;
    };
  }, []);

  return (
    <section id="hero" className="sectiune-hero relative overflow-hidden">
      <h1 className="hero-title">{ro.hero.title}</h1>

      <p className="moto-left">{ro.hero.motoLeft}</p>
      <p className="moto-right">{ro.hero.motoRight}</p>

      <div className="hero-image">
        <img
          src="/images/poza_stefan.png"
          alt={ro.hero.imageAlt}
          className="hero-stefan-img"
        />
      </div>

      {/* Social icons overlay */}
      <div className="hero-socials" aria-label={ro.hero.socialAria}>
        {/* CTA: merge la Simulare Traseu / Inscriere */}
        <a
          href="#simulare"
          className="hero-social-btn cta"
          aria-label={ro.hero.cta.aria}
          title={ro.hero.cta.title}
        >
          {/* dumbbell icon */}
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="currentColor"
            aria-hidden
          >
            <path d="M2 9h2v6H2V9Zm3-3h2v12H5V6Zm12 0h2v12h-2V6Zm5 3v6h-2V9h2ZM9 10h6v4H9v-4Z" />
          </svg>
        </a>
        <a
          href="https://wa.me/40761677022"
          target="_blank"
          rel="noreferrer noopener"
          className="hero-social-btn whatsapp"
          aria-label={ro.hero.socials.whatsapp}
          title={ro.hero.socials.whatsapp}
        >
          <svg
            viewBox="0 0 24 24"
            width="22"
            height="22"
            fill="currentColor"
            aria-hidden
          >
            <path d="M20.52 3.48A11.92 11.92 0 0 0 12.06 0C5.5 0 .2 5.29.2 11.82c0 2.08.54 4.1 1.59 5.9L0 24l6.44-1.66a11.74 11.74 0 0 0 5.62 1.44h.01c6.56 0 11.87-5.29 11.87-11.82 0-3.17-1.24-6.16-3.42-8.48ZM12.07 21.3c-1.77 0-3.5-.46-5.02-1.33l-.36-.21-3.82.99 1.02-3.72-.23-.38A9.63 9.63 0 0 1 2.4 11.8c0-5.32 4.38-9.64 9.77-9.64 2.61 0 5.05 1.01 6.89 2.83a9.51 9.51 0 0 1 2.9 6.81c0 5.32-4.38 9.64-9.89 9.64Zm5.67-7.17c-.31-.16-1.86-.9-2.15-1.01-.29-.11-.5-.16-.72.16-.21.32-.83 1.01-1.02 1.22-.19.21-.37.24-.69.08-.31-.16-1.31-.48-2.49-1.52-.92-.79-1.54-1.77-1.72-2.07-.18-.32-.02-.49.14-.65.14-.14.31-.37.46-.56.15-.19.2-.32.31-.53.1-.21.05-.39-.03-.55-.08-.16-.72-1.73-.99-2.36-.26-.63-.53-.53-.72-.53h-.62c-.21 0-.55.08-.83.39-.29.32-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.22 3.39 5.38 4.75.75.32 1.34.51 1.8.65.76.24 1.45.2 2 .12.61-.09 1.86-.76 2.12-1.49.26-.73.26-1.36.18-1.49-.08-.13-.29-.21-.6-.37Z" />
          </svg>
        </a>
        <a
          href="https://www.instagram.com/stefancelmare_ptrainer?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
          target="_blank"
          rel="noreferrer noopener"
          className="hero-social-btn instagram"
          aria-label={ro.hero.socials.instagram}
          title={ro.hero.socials.instagram}
        >
          <svg
            viewBox="0 0 24 24"
            width="22"
            height="22"
            fill="currentColor"
            aria-hidden
          >
            <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3.5A5.5 5.5 0 1 1 6.5 13 5.51 5.51 0 0 1 12 7.5Zm0 2A3.5 3.5 0 1 0 15.5 13 3.5 3.5 0 0 0 12 9.5Zm5.75-3.25a1.25 1.25 0 1 1-1.25 1.25 1.25 1.25 0 0 1 1.25-1.25Z" />
          </svg>
        </a>
        <a
          href="https://www.tiktok.com/@traseuaplicativconstanta?is_from_webapp=1&sender_device=pc"
          target="_blank"
          rel="noreferrer noopener"
          className="hero-social-btn tiktok"
          aria-label={ro.hero.socials.tiktok}
          title={ro.hero.socials.tiktok}
        >
          <svg
            viewBox="0 0 24 24"
            width="22"
            height="22"
            fill="currentColor"
            aria-hidden
          >
            <path d="M21 8.5a7.5 7.5 0 0 1-5.5-2.4V17a5.5 5.5 0 1 1-5.5-5.5c.34 0 .67.03 1 .1V14a2.5 2.5 0 1 0 2.5 2.5V2h3a7.5 7.5 0 0 0 4.5 4.5Z" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Hero;
